import React, { useState, useCallback, useEffect } from 'react';
import { Box, Button, Select, MenuItem, FormControl, InputLabel, CircularProgress, FormHelperText, Typography } from '@mui/material';
import '../../mentorComponents/labPractice/LabPractice.css';
import { getAllCOE } from '../../../services/adminServices/CoeServices';
import { toast } from 'react-toastify';
import { getAllCoeLabs } from '../../../services/mentorServices/DailyPracticeServices';
import MentorPracticeTable from './MentorPracticeTable';
import { getDailyPracticeReport } from '../../../services/reportServices/mentorReportServices/PracticeReportServices';

const MentorDailyPracticeReport = () => {
    const [selection, setSelection] = useState({ lab: '', coe: '' });
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [error, setError] = useState({ lab: '', coe: '' });
    const [coes, setCoe] = useState([]);
    const [labNames, setlabNames] = useState([]);

    const handleSelectionChange = (event) => {
        const { name, value } = event.target;
        setSelection((prev) => ({ ...prev, [name]: value }));
        if (name === "coe")
            fetchlabs(value)
        setError((prev) => ({ ...prev, [name]: '' }));
    };
    const fetchData = useCallback(async () => {
        const { lab, coe } = selection;

        if (!lab || !coe) {
            setError({
                lab: lab ? '' : 'Please select a Lab',
                coe: coe ? '' : 'Please select a COE',
            });
            return;
        }
        setLoading(true);
        try {
            const response = await getDailyPracticeReport(coe, lab)
            setTableData(response.data.data);
            setShowTable(true);
        } catch (error) {
            toast.error(error?.response?.data.message || error?.message || error?.error);
            setTableData([])
        } finally {
            setLoading(false);
        }
    }, [selection]);
    const getCoe = async () => {
        const response = await getAllCOE()
        setCoe(response.data.data)
    }
    const fetchlabs = useCallback(async (coeId) => {
        try {
            const response = await getAllCoeLabs(coeId);
            const labDetails = response?.data.data;
            setlabNames(labDetails)
        } catch (error) {
            setlabNames([])
            setTableData([])
            setSelection(prev => ({ ...prev, lab: '' }));
            toast.error(error?.response?.data.message || error?.message || error?.error);
        }
    }, []);

    useEffect(() => {
        getCoe()
    }, [])

    return (
        <Box className="dashboard-container" sx={{ justifyContent: "flex-start !important" }}>
            <Typography className="dashboard-header-title" pt={2} pb={4} width="100%">
                Welcome {JSON.parse(localStorage.getItem("user"))?.name || "User"}! to the Daily Practice Report.
            </Typography>
            <Box className="DailyPractice-header">
                <Box className="daily-practice-inputs" display="flex" width="60%" alignItems="center">
                    <FormControl className="lab-name-select" size='small' sx={{ width: "43% !important" }} error={!!error.coe}>
                        <InputLabel id="coe-select-label">COE*</InputLabel>
                        <Select
                            labelId="coe-select-label"
                            id="coe-select"
                            name="coe"
                            value={selection.coe}
                            onChange={handleSelectionChange}
                            label="COE"
                        >
                            {coes.map((coe, index) => (
                                <MenuItem key={index} value={coe.id}>
                                    {coe.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {error.coe && <FormHelperText>{error.coe}</FormHelperText>}
                    </FormControl>
                    <FormControl className="lab-name-select" size='small' sx={{ width: "43% !important" }} error={!!error.lab}>
                        <InputLabel id="lab-select-label">Lab Name*</InputLabel>
                        <Select
                            labelId="lab-select-label"
                            id="lab-select"
                            name="lab"
                            value={selection.lab}
                            onChange={handleSelectionChange}
                            label="Lab Name"
                        >
                            {labNames.map((lab, index) => (
                                <MenuItem key={index} value={lab.id}>
                                    {lab.lab_name}
                                </MenuItem>
                            ))}
                        </Select>
                        {error.lab && <FormHelperText>{error.lab}</FormHelperText>}
                    </FormControl>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={fetchData}
                        className="dashboard-header-button"
                        disabled={loading || !selection.lab || !selection.coe}                 >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'VIEW'}
                    </Button>
                </Box>
            </Box>
            <Box className="dashboard-box-container">
                {showTable && <MentorPracticeTable data={tableData} loading={loading} selection={selection} />}
            </Box>
        </Box>
    );
};

export default MentorDailyPracticeReport;
